import sidebarBg from '@/assets/img/user/背景卡图.png';
import userLogo from '@/assets/img/user/avatar.png';
import menuProfileIcon from '@/assets/img/user/griconxz.png';
import menuProfileInactiveIcon from '@/assets/img/user/gricon.png';
import menuApplyActiveIcon from '@/assets/img/user/申请icon.png';
import menuApplyInactiveIcon from '@/assets/img/user/申请未选中.png';
import personalTag from '@/assets/img/user/个人主播.png';
import douyinLogo from '@/assets/img/user/抖音.png';
import kuaishouLogo from '@/assets/img/user/快手.png';
import bilibiliLogo from '@/assets/img/user/b站.png';

function hasWindow() {
  return typeof window !== 'undefined' && !!window.localStorage;
}

function formatDate(value) {
  if (!value) {
    return '--';
  }

  return String(value).slice(0, 10);
}

function getUserRoleText(userInfo) {
  if (userInfo && userInfo.type_text) {
    return userInfo.type_text;
  }

  if (userInfo && userInfo.type === 'individual') {
    return '个人主播';
  }

  return '个人主播';
}

export function getCachedUserInfo() {
  if (!hasWindow()) {
    return {};
  }

  try {
    const raw = window.localStorage.getItem('userInfo');
    return raw ? JSON.parse(raw) : {};
  } catch (error) {
    return {};
  }
}

export function createPersonalProfile() {
  const userInfo = getCachedUserInfo();
  return {
    name: userInfo.name || '用户名字666',
    role: getUserRoleText(userInfo),
    avatar: userInfo.avatar || userLogo,
    background: sidebarBg
  };
}

export function createPersonalBasicInfo() {
  const userInfo = getCachedUserInfo();
  return {
    platformId: userInfo.account_no || '--',
    registerDate: formatDate(userInfo.created_at)
  };
}

export function createPersonalQuickInfo() {
  const userInfo = getCachedUserInfo();
  return [
    { label: '姓名', value: userInfo.name || '--' },
    { label: '手机号', value: userInfo.phone || '--' },
    { label: '身份类型', value: getUserRoleText(userInfo) },
    { label: '身份证号', value: userInfo.id_card_no || '未认证' }
  ];
}

export const personalProfile = createPersonalProfile();
export const personalBasicInfo = createPersonalBasicInfo();
export const personalQuickInfo = createPersonalQuickInfo();

export const personalMenuAssets = {
  profile: menuProfileIcon,
  applyActive: menuApplyActiveIcon,
  applyInactive: menuApplyInactiveIcon,
  personalTag,
  platformLogoMap: {
    抖音: douyinLogo,
    快手: kuaishouLogo,
    B站: bilibiliLogo
  }
};

export const platformOptions = [
  { value: 'douyin', label: '抖音' },
  { value: 'kuaishou', label: '快手' },
  { value: 'bilibili', label: 'B站' },
  { value: 'xiaohongshu', label: '小红书' },
  { value: 'weibo', label: '微博' },
  { value: 'wechat_video', label: '微信视频号' }
];

export const categoryOptions = [
  { value: 'beauty_care', label: '美妆护肤' },
  { value: 'fashion_apparel', label: '服饰穿搭' },
  { value: 'food_beverage', label: '食品饮料' },
  { value: 'digital', label: '3C数码' },
  { value: 'home_living', label: '家居生活' },
  { value: 'maternity_child', label: '母婴育儿' },
  { value: 'education', label: '教育知识' },
  { value: 'sports_outdoors', label: '运动户外' },
  { value: 'gaming', label: '游戏电竞' }
];

export const anchorTypeOptions = [
  { value: 'full_time', label: '全职' },
  { value: 'part_time', label: '兼职' }
];

export const businessDirectionOptions = [
  { value: 'live_commerce', label: '直播带货' },
  { value: 'content', label: '内容创作' },
  { value: 'knowledge', label: '知识付费' },
  { value: 'entertainment', label: '娱乐直播' }
];

export const platformLabelMap = platformOptions.reduce((accumulator, item) => {
  accumulator[item.value] = item.label;
  return accumulator;
}, {});

export const categoryLabelMap = categoryOptions.reduce((accumulator, item) => {
  accumulator[item.value] = item.label;
  return accumulator;
}, {});

export const anchorTypeLabelMap = anchorTypeOptions.reduce((accumulator, item) => {
  accumulator[item.value] = item.label;
  return accumulator;
}, {});

export const businessDirectionLabelMap = businessDirectionOptions.reduce((accumulator, item) => {
  accumulator[item.value] = item.label;
  return accumulator;
}, {});

export function createPersonalMenu() {
  return [
    { key: 'profile', 
	label: '个人中心', 
	path: '/user/personal', 
	activeIcon: menuProfileIcon,
	inactiveIcon: menuProfileInactiveIcon
	},
    {
      key: 'apply',
      label: '我的申请',
      path: '/user/personal/applications',
      activeIcon: menuApplyActiveIcon,
      inactiveIcon: menuApplyInactiveIcon
    }
  ];
}

export function getPlatformShortName(platform) {
  const platformLabel = platformLabelMap[platform] || platform;
  if (platformLabel === '微信视频号') {
    return '微';
  }
  return String(platformLabel || '').slice(0, 1);
}

export function createDefaultPlatformCards() {
  return [
    { id: 1, platform: '抖音', name: '大力出奇迹', fans: '205万', category: '游戏电竞', accountId: 'dy11223877121' },
    { id: 2, platform: '快手', name: '大力666', fans: '215万', category: '游戏电竞', accountId: 'ks11223877121' },
    { id: 3, platform: 'B站', name: '大力出奇迹11', fans: '205万', category: '游戏电竞', accountId: 'bili11223877121' }
  ];
}

export function createEmptyPlatformForm() {
  return {
    platform: '',
    name: '',
    fans: '',
    category: '',
    accountId: ''
  };
}

export function createEmptyApplicationAccount() {
  return {
    id: Date.now() + Math.random(),
    platform: '',
    nickname: '',
    platformId: '',
    fansCount: '',
    verticalTrack: ''
  };
}

function normalizeCachedApplicationAccount(item, index) {
  const source = item && typeof item === 'object' ? item : {};
  return {
    ...createEmptyApplicationAccount(),
    id: source.id || `cached-platform-${index}`,
    platform: source.platform || '',
    nickname: source.nickname || source.name || source.account_name || '',
    platformId: source.platform_id || source.account_id || source.account_no || source.platform_account_id || '',
    fansCount: source.fans_count || source.fans || source.followers_count || '',
    verticalTrack: source.vertical_track || source.category || ''
  };
}

export function createDefaultApplicationAccounts() {
  const userInfo = getCachedUserInfo();
  const platformAccounts = Array.isArray(userInfo.platform_accounts) ? userInfo.platform_accounts : [];

  if (!platformAccounts.length) {
    return [createEmptyApplicationAccount()];
  }

  return platformAccounts.map((item, index) => normalizeCachedApplicationAccount(item, index));
}

export function createDefaultEvidenceFiles() {
  return [
    { key: 'incomeProof', label: '收入证明上传', fileName: '', url: '' },
    { key: 'ownershipProof', label: '账号权属证明', fileName: '', url: '' },
    { key: 'businessProof', label: '商业/品牌合作', fileName: '', url: '' }
  ];
}

export function createEmptyApplicationForm(options = {}) {
  const { useCachedAccounts = false } = options;
  const userInfo = getCachedUserInfo();
  const ownerName = userInfo.name || '';
  const ownerIdNo = userInfo.id_card_no && !String(userInfo.id_card_no).includes('*')
    ? userInfo.id_card_no
    : '';
  return {
    assetName: ownerName ? `${ownerName}个人主播` : '',
    assetCategory: '主播资产',
    ownerName,
    ownerIdNo,
    residence: '',
    honors: '',
    streamerType: '',
    contentDirection: '',
    accounts: useCachedAccounts ? createDefaultApplicationAccounts() : [createEmptyApplicationAccount()],
    operation: {
      totalFans: '',
      worksStats: '',
      liveSessionsStats: '',
      monthlyLiveHours: '',
      fanGrowth: '',
      commercialCooperation: '',
      annualIncome: ''
    },
    evidenceFiles: createDefaultEvidenceFiles(),
    forecast: {
      shortTerm: '',
      lifecycle: '',
      basis: ''
    }
  };
}
